import config from "@/config/config";
import { Credential } from "@/domain/credentials.model";
import { LoginResponse } from "@/domain/login.model";
import httpClient from "@/helpers/http-client";
import { headers } from "./headers";

export class CredentialService {
  private static urlApiBase = config.url_api_base;

  static login = (accessKey: string, secretKey: string): Promise<LoginResponse> => {
    return httpClient
      .request<LoginResponse>({
        url: `${this.urlApiBase}/credentials/auth`,
        method: "POST",
        body: {
          accessKey,
          secretKey,
        },
      })
      .then(result => result?.body);
  };

  static getCredentials = (): Promise<Credential[]> => {
    return httpClient
      .request<Credential[]>({
        url: `${this.urlApiBase}/credentials`,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static insert = (data: Credential): Promise<Credential> => {
    return httpClient
      .request<Credential>({
        url: `${this.urlApiBase}/credentials`,
        method: "POST",
        headers: headers(),
        body: data,
      })
      .then(result => result?.body);
  };

  static changeStatus = (accessKey: string, enabled: boolean): Promise<Credential> => {
    return httpClient
      .request<Credential>({
        url: `${this.urlApiBase}/credentials/${accessKey}/change-status`,
        method: "POST",
        headers: headers(),
        body: {
          enabled,
        },
      })
      .then(result => result?.body);
  };
}
